/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2023 Comcast Cable Communications Management, LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Class that keeps track of the invocations of Context methods when
 * the `enableContextSpy` renderer option is enabled.
 */
export class ContextSpy {
    data = {};
    reset() {
        this.data = {};
    }
    increment(name) {
        if (!this.data[name]) {
            this.data[name] = 0;
        }
        this.data[name]++;
    }
    getData() {
        return { ...this.data };
    }
}
//# sourceMappingURL=ContextSpy.js.map